import { fetchConstants } from '@apis/constant'
import { locales } from '@locales'
import { getLocale, setLocale } from '@utils/locale'
import Vue from 'vue'

export const state = {
  constants: null,
  config: null,
  locales,
  locale: getLocale(),
}

export const mutations = {
  SET_CONSTANTS(state, newValue) {
    state.constants = newValue
  },
  SET_LOCALE(state, locale) {
    state.locale = locale
    setLocale(locale)
  },
}

export const getters = {
  // Whether the user is currently logged in.
  is_inited(state) {
    return !!state.constants
  },
}

export const actions = {
  init({ dispatch }) {
    Promise.all([dispatch('getConstants')]).catch((e) =>
      Vue.toasted.error(e.message)
    )
  },

  async getConstants({ commit }) {
    const { constants } = await fetchConstants()

    commit('SET_CONSTANTS', constants)
    return constants
  },
  async SetLocale({ commit, dispatch }, locale) {
    commit('SET_LOCALE', locale)
    return Promise.all([dispatch('getConstants')])
  },
}
